module.exports = __webpack_public_path__ + "image/Percheron_1.png";